import React, { createContext, useContext, useState, useEffect } from "react";
import {
  setAccessToken,
  clearAccessToken,
  getAccessToken,
} from "../api/axiosInstance";
import AuthAPI from "../api/authApi";
import { UserContext } from "../utils/UserContext";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const { setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    initializeAuth();
  }, []);

  const initializeAuth = async () => {
    try {
      const res = await AuthAPI.refreshToken();

      if (res?.code === 200 && res?.data?.accessToken) {
        setAccessToken(res.data.accessToken);

        const storedUser = localStorage.getItem("user");
        if (storedUser) {
          setUser(JSON.parse(storedUser));
        }
      } else {
        throw new Error("Invalid refresh response");
      }
    } catch (error) {
      console.log("❌ Auth failed:", error.message);
      clearAccessToken();
      localStorage.removeItem("user");
      setUser(null);
      localStorage.removeItem("selectedStore");
      localStorage.removeItem("selectedStoreID");
      localStorage.removeItem("selectedStoreName");
    } finally {
      setLoading(false);
      setIsInitialized(true);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        loading,
        isInitialized,
        isAuthenticated: !!getAccessToken(),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook
export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};
